import { Product } from '../types';

// ============================================
// ROUND CONNECTORS
// ============================================

// ROUND CONNECTORS - 1-4 POLE
export const roundConnectorProducts: Product[] = [
  {
    id: "round-conn-maruti-zen-fuse-link-1p-f",
    name: "Maruti Zen Fuse Link 1 Pole Female - Round",
    slug: "round-maruti-zen-fuse-link-1-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Maruti Zen fuse link 1 pole female round connector with 5mm deluxe wire.",
    partNumber: "SH0600101F",
    image: "/products/round-connectors/round-holder/SH0600101F.jpg",
    featured: true,
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Maruti Zen Fuse Link",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "1-pole", "maruti", "zen", "fuse-link", "female"],
    applications: ["Maruti Zen", "Fuse Link"],
  },
  {
    id: "round-conn-maruti-zen-fuse-link-1p-m",
    name: "Maruti Zen Fuse Link 1 Pole Male - Round",
    slug: "round-maruti-zen-fuse-link-1-pole-male",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Maruti Zen fuse link 1 pole male round connector with 5mm deluxe wire.",
    partNumber: "SH0600101M",
    image: "/products/round-connectors/round-holder/SH0600101M.jpg",
    featured: true,
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Male",
      "Type": "Round Connector",
      "Compatible": "Maruti Zen Fuse Link",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "1-pole", "maruti", "zen", "fuse-link", "male"],
    applications: ["Maruti Zen", "Fuse Link"],
  },
  {
    id: "round-conn-al-new-model-1p-f",
    name: "Ashok Leyland New Model 1 Pole Female - Round",
    slug: "round-al-new-model-1-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Ashok Leyland new model 1 pole female round connector with 8mm deluxe wire.",
    partNumber: "SH0600102F",
    image: "/products/round-connectors/round-holder/SH0600102F.jpg",
    specifications: {
      "Poles": "1 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "1-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "round-conn-jeep-erickshaw-2p-f",
    name: "Jeep and E-Rickshaw 2 Pole Female - Round",
    slug: "round-jeep-erickshaw-2-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Jeep and E-Rickshaw 2 pole female round connector with 5mm deluxe wire.",
    partNumber: "SH0600201F",
    image: "/products/round-connectors/round-holder/SH0600201F.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Jeep and E-Rickshaw",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "2-pole", "jeep", "erickshaw", "female"],
    applications: ["Jeep", "E-Rickshaw"],
  },
  {
    id: "round-conn-jeep-erickshaw-2p-m",
    name: "Jeep and E-Rickshaw 2 Pole Male - Round",
    slug: "round-jeep-erickshaw-2-pole-male",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Jeep and E-Rickshaw 2 pole male round connector with 5mm deluxe wire.",
    partNumber: "SH0600201M",
    image: "/products/round-connectors/round-holder/SH0600201M.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Type": "Round Connector",
      "Compatible": "Jeep and E-Rickshaw",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "2-pole", "jeep", "erickshaw", "male"],
    applications: ["Jeep", "E-Rickshaw"],
  },
  {
    id: "round-conn-fan-motor-zen-esteem-3p-f",
    name: "Fan Motor Zen/Maruti Car Type II/Esteem 3 Pole Female - Round",
    slug: "round-fan-motor-zen-maruti-esteem-3-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Fan motor for Zen, Maruti Car Type II, Esteem 3 pole female round connector with 5mm deluxe wire.",
    partNumber: "SH0600301F",
    image: "/products/round-connectors/round-holder/SH0600301F.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Fan Motor - Zen, Maruti Car Type II, Esteem",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "3-pole", "fan-motor", "zen", "maruti", "esteem", "female"],
    applications: ["Maruti Zen", "Maruti Esteem", "Fan Motor"],
  },
  {
    id: "round-conn-fan-motor-zen-esteem-3p-m",
    name: "Fan Motor Zen/Maruti Car Type II/Esteem 3 Pole Male - Round",
    slug: "round-fan-motor-zen-maruti-esteem-3-pole-male",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Fan motor for Zen, Maruti Car Type II, Esteem 3 pole male round connector with 5mm deluxe wire.",
    partNumber: "SH0600301M",
    image: "/products/round-connectors/round-holder/SH0600301M.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Type": "Round Connector",
      "Compatible": "Fan Motor - Zen, Maruti Car Type II, Esteem",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "3-pole", "fan-motor", "zen", "maruti", "esteem", "male"],
    applications: ["Maruti Zen", "Maruti Esteem", "Fan Motor"],
  },
  {
    id: "round-conn-injector-maruti-van-3p-f",
    name: "Injector Maruti Van 3 Pole Female - Round",
    slug: "round-injector-maruti-van-3-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Injector for Maruti Van 3 pole female round connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0600302",
    image: "/products/round-connectors/round-holder/SH0600302.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Maruti Van Injector",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "3-pole", "injector", "maruti", "van", "female"],
    applications: ["Maruti Van", "Injector"],
  },
  {
    id: "round-conn-fan-motor-zen-esteem-4p-f",
    name: "Fan Motor Zen/Maruti Car Type II/Esteem 4 Pole Female - Round",
    slug: "round-fan-motor-zen-maruti-esteem-4-pole-female",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Fan motor for Zen, Maruti Car Type II, Esteem 4 pole female round connector with 4mm deluxe wire.",
    partNumber: "SH0600401F",
    image: "/products/round-connectors/round-holder/SH0600401F.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Round Connector",
      "Compatible": "Fan Motor - Zen, Maruti Car Type II, Esteem",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "4-pole", "fan-motor", "zen", "maruti", "esteem", "female"],
    applications: ["Maruti Zen", "Maruti Esteem", "Fan Motor"],
  },
  {
    id: "round-conn-fan-motor-zen-esteem-4p-m",
    name: "Fan Motor Zen/Maruti Car Type II/Esteem 4 Pole Male - Round",
    slug: "round-fan-motor-zen-maruti-esteem-4-pole-male",
    category: "Round Connectors",
    subcategory: "Round Connectors",
    description: "Fan motor for Zen, Maruti Car Type II, Esteem 4 pole male round connector with 4mm deluxe wire.",
    partNumber: "SH0600401M",
    image: "/products/round-connectors/round-holder/SH0600401M.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Type": "Round Connector",
      "Compatible": "Fan Motor - Zen, Maruti Car Type II, Esteem",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["round-connector", "4-pole", "fan-motor", "zen", "maruti", "esteem", "male"],
    applications: ["Maruti Zen", "Maruti Esteem", "Fan Motor"],
  },
];
